module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-header"
  }, [_c('div', {
    staticClass: "header-main content"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../static/img/index/headtitle.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-search"
  }, [_c('div', {
    staticClass: "input-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    staticClass: "form-control dropdown-toggle",
    attrs: {
      "type": "text",
      "data-toggle": "dropdown",
      "placeholder": "请输入您要搜索的内容",
      "aria-expanded": "false"
    },
    domProps: {
      "value": (_vm.key)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.openSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openSearch
    }
  }, [_vm._v("搜 索")])])]), _vm._v(" "), _c('div', {
    staticClass: "hotsearch",
    on: {
      "click": function($event) {
        return _vm.openNewPage('https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("路标式政务服务事项解读体系")]), _vm._v(" "), _c('img', {
    staticClass: "gzjz",
    attrs: {
      "src": require("../../static/img/index/gzjz.png")
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#FAFAFB"
    }
  }, [_c('div', {
    staticClass: "Bsjd content",
    attrs: {
      "id": "bsjd"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "left-right"
  }, [_c('div', {
    staticClass: "bsjdMain"
  }, [_c('div', {
    staticClass: "swiper img-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/jd-img1.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://mp.weixin.qq.com/s/CY4xQf3Ldd53s7-S8NKSJQ')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/jd-img2.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://mp.weixin.qq.com/s/CY4xQf3Ldd53s7-S8NKSJQ')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next-img swiper-button-next3"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev-img swiper-button-prev3"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-table"
  }, [_c('div', {
    staticClass: "bsjd-body"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("文件依据")]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item",
    on: {
      "click": _vm.openExplain
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._v("2023-05-10")])]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item",
    on: {
      "click": _vm.openExplain
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', [_vm._v("2023-05-10")])]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item",
    on: {
      "click": _vm.openExplain
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', [_vm._v("2023-05-10")])]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item",
    on: {
      "click": _vm.openExplain
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', [_vm._v("2023-05-10")])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "zcdx content",
    attrs: {
      "id": "zcdx"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "zcdxmain"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "zcjsq"
  }, [_c('div', {
    staticClass: "zcdxTitle"
  }, [_vm._v("政策计算器")]), _vm._v(" "), _c('div', {
    staticClass: "zcjsqmain",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://thzwb.thnet.gov.cn/policy/#/calculator')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/calculator.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("政策计算器")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("联合申报、协同审批")])])])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "Leftnav"
  }, [_c('ul', [_c('li', {
    class: [_vm.isInArea1 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(1)
      }
    }
  }, [_c('a', [_vm._v("路标式解读")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea2 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(2)
      }
    }
  }, [_c('a', [_vm._v("场景式导办")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea3 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(3)
      }
    }
  }, [_c('a', [_vm._v("\"一件事\" 导航图")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea4 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(4)
      }
    }
  }, [_c('a', [_vm._v("地图导航")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea5 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(5)
      }
    }
  }, [_c('a', [_vm._v("政策兑现")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea6 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(6)
      }
    }
  }, [_c('a', [_vm._v("高频事项")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Topmatter content"
  }, [_c('div', {
    staticClass: "listcon"
  }, [_c('div', {
    staticClass: "listname"
  }, [_vm._v("非学历教育机构设立")]), _vm._v(" "), _c('div', {
    staticClass: "listbutton"
  }, [_c('a', {
    staticClass: "reservation",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("在线预约")]), _vm._v(" "), _c('a', {
    staticClass: "guide",
    attrs: {
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001"
    }
  }, [_vm._v("办事指南")])])]), _vm._v(" "), _c('div', {
    staticClass: "ewm"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/ewm.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("使用微信扫码登录")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conTitle detailConTitle1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-lbsjd.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://tyj.gd.gov.cn/sjzw_zcfg/content/post_4014027.html"
    }
  }, [_vm._v("广东省体育局 广东省教育厅关于印发《广东省体育类校外培训机构设置标准（试行）》的通知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://gdstc.gd.gov.cn/zwgk_n/zcfg/gfwj/content/post_4014069.html"
    }
  }, [_vm._v("广东省科学技术厅 广东省教育厅关于印发《广东省科技类校外培训机构设置标准（试行）》的通知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://whly.gd.gov.cn/open_newggl/content/post_4037344.html"
    }
  }, [_vm._v("广东省文化和旅游厅 广东省教育厅关于印发《广东省文化艺术类校外培训机构设置标准（试行）》的通知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://edu.gd.gov.cn/ztzlnew/xxl/tzgg/content/post_4065465.html"
    }
  }, [_vm._v("广东省教育厅等六部门关于印发非学科类校外培训机构办学许可证审批流程指引（试行）的通知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Znyd content",
    attrs: {
      "id": "znyd"
    }
  }, [_c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-cjsdb.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "znydMain"
  }, [_c('div', {
    staticClass: "yd-qx"
  }, [_c('div', {
    staticClass: "title-h",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "image-c"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/intelligent/robort.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("选择办事情形")])]), _vm._v(" "), _c('div', {
    staticClass: "yd-qx-list"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "qx-rom"
  }, [_c('div', {
    staticClass: "romtit"
  }, [_vm._v("1.请选择培训机构营利类型：")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn1 active1"
  }, [_vm._v("非营利性培训机构")]), _vm._v(" "), _c('div', {
    staticClass: "btn1"
  }, [_vm._v("营利性培训机构")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yd-qx-list"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "qx-rom"
  }, [_c('div', {
    staticClass: "romtit"
  }, [_vm._v("2.请选择举办者类型：")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn1 active1"
  }, [_vm._v("社会组织")]), _vm._v(" "), _c('div', {
    staticClass: "btn1"
  }, [_vm._v("个人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yd-qx-list"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "qx-rom"
  }, [_c('div', {
    staticClass: "romtit"
  }, [_vm._v("3.请选择办学场所类型:")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn1 active1"
  }, [_vm._v("自有场所举办")])]), _vm._v(" "), _c('div', {
    staticClass: "rominfo"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("已办理房屋产权证\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("未办理房屋产权证\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yd-qx-list"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "qx-rom"
  }, [_c('div', {
    staticClass: "romtit"
  }, [_vm._v("4.请问是否有在线培训业务？：")]), _vm._v(" "), _c('div', {
    staticClass: "rominfo"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("是\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("否\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yd-qx-list"
  }, [_c('div', {
    staticClass: "guide-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "qx-rom"
  }, [_c('div', {
    staticClass: "romtit"
  }, [_vm._v("5.请选择本学形式：")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn1 active1"
  }, [_vm._v("联合办学（两个以上举办者联合举办）")]), _vm._v(" "), _c('div', {
    staticClass: "btn1"
  }, [_vm._v("单独举办")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-cl"
  }, [_c('div', {
    staticClass: "clMain"
  }, [_c('div', {
    staticClass: "cltitle"
  }, [_vm._v("需要提供的材料(3)")]), _vm._v(" "), _c('div', {
    staticClass: "cltable"
  }, [_c('div', {
    staticClass: "tablehead"
  }, [_c('span', {
    staticClass: "clname"
  }, [_vm._v("申请材料名称(通用材料)")]), _vm._v(" "), _c('span', {
    staticClass: "clzt"
  }, [_vm._v("状态")])]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("1.广东省非学科类校外培训机构设立申请表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("3.营业执照或者其他主体资格证明文件")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("免提交")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("2.开立临时存款账户通知书或企业名称自主申报告知书")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("3.申办报告")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("4.机构章程")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("5.开办资金、注册资本有效证明文件")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("6.培训场所内部结构平面图")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("7.消防安全证明材料")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("8.设施设备情况表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("9.拟任首届董（理）事会或者其他决策机构组成人员、监事会明细表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("10.（拟任）校长（行政负责人）履历表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("11.（拟聘用）从业人员明细表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("12.培训机构党员名单")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("13.拟用培训材料备案表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cltable"
  }, [_c('div', {
    staticClass: "tablehead"
  }, [_c('span', {
    staticClass: "clname"
  }, [_vm._v("申请材料名称（特殊条件材料【办事情形】)")]), _vm._v(" "), _c('span', {
    staticClass: "clzt"
  }, [_vm._v("状态")])]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("1.1 非营利性机构：开办资金已全部缴足的验资报告、捐赠协议")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("1.2 营利性培训机构")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("免提交")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("2.1 社会组织：举办者的资质文件（包括营业执照或民办非企业单位登记证书复印件、信用状况良好承诺书，其法定代表人的有效身份证件复印件、法定代表人信用状况良好和无犯罪记录承诺书）")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("2.2 个人： 举办者的资质文件（包括有效身份证件复印件、信用状况良好承诺书、无犯罪记录承诺书）")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("3.1 自有场所举办: 不动产权证、房地产权证或房屋所有权证等，并提供查询内容为房产登记、抵押、查封信息的不动产登记查册表")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("3.1.1 已办理房屋产权证")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("免提交")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("3.1.2 未办理房屋产权证：土地使用权或所有权文件及建设工程报建、验收文件；或镇政府、街道办事处、土地房屋管理部门出具的产权文件等")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("4.1 有在线培训业务：网站（或教育APP）测试账号以及电信与信息服务业务经营（ICP）备案证明等材料")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("4.2 无在线培训业务")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("免提交")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("5.1 联合办学（两个以上举办者联合举办）：联合办学协议")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("待提供")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "clname"
  }, [_vm._v("5.2 单独举办")]), _vm._v(" "), _c('div', {
    staticClass: "clzt"
  }, [_vm._v("免提交")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#E8F2FF",
      "padding": "1px 0px 20px"
    }
  }, [_c('div', {
    staticClass: "yjsdb content",
    attrs: {
      "id": "yjsdb"
    }
  }, [_c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-yjs.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "yjsdbMain"
  }, [_c('div', {
    staticClass: "yjsnav"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "LiActive",
    attrs: {
      "id": "nav_li1",
      "onclick": "setContentTab('nav_li',1,3)"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/db-icon1.png")
    }
  }), _vm._v("我要开餐馆")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "nav_li2",
      "onclick": "setContentTab('nav_li',2,3)"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/db-icon2.png")
    }
  }), _vm._v("我要开饭店")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "nav_li3",
      "onclick": "setContentTab('nav_li',3,3)"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/db-icon3.png")
    }
  }), _vm._v("我要开酒店")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap",
    attrs: {
      "id": "con_nav_li_1"
    }
  }, [_c('div', {
    staticClass: "type-wrap"
  }, [_c('div', {
    staticClass: "side"
  }, [_c('ul', {
    attrs: {
      "id": "group-list"
    }
  }, [_c('li', {
    attrs: {
      "data-group-code": "QYSLDJ"
    }
  }, [_c('span', [_vm._v("企业设立登记")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-group-code": "GTGSHZCDJ"
    }
  }, [_c('span', [_vm._v("个体工商户注册登记")])]), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "data-group-code": "WSPRPSGWXKZHF"
    }
  }, [_c('span', [_vm._v("污水排入排水管网许可证核发")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-group-code": "GGSP"
    }
  }, [_c('span', [_vm._v("在城市建筑物、设施上悬挂、张贴宣传品审批 /设置大型户外广告审批")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-group-code": "SSSQRCNZDXCY"
    }
  }, [_c('span', [_vm._v("实施申请人承诺制的小餐饮")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-group-code": "JGYSXFBA"
    }
  }, [_c('span', [_vm._v("竣工验收消防备案")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-group-code": "HWZPSZBA"
    }
  }, [_c('span', [_vm._v("户外招牌设置备案")])])])]), _vm._v(" "), _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "flowTitle"
    }
  }, [_vm._v("我要经营餐饮店铺 新开")]), _vm._v(" "), _c('div', {
    staticClass: "tabs",
    attrs: {
      "id": "scenes"
    }
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:sceneClick('b09f6e97-d798-43cb-97e6-f7b21f003211')",
      "title": "建筑面积50平以下（平方米）"
    }
  }, [_vm._v("建筑面积50平以下（平方米）")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:sceneClick('1cdcb23c-a6f0-48ae-8921-8bea213c414d')",
      "title": "建筑面积50平至10000平（平方米）"
    }
  }, [_vm._v("建筑面积50平至10000平（平方米）")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:sceneClick('02edd816-1aa8-4f42-9db5-5b3d0f2588d3')",
      "title": "建筑面积：10000平以上"
    }
  }, [_vm._v("建筑面积：10000平以上")])]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "step-img",
      "src": require("../../static/img/details/uploadify1.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con_nav_li_2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con_nav_li_3"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content hall",
    attrs: {
      "id": "dtdh"
    }
  }, [_c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-dtdh.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapContanier",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "24px"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://thzwb.thnet.gov.cn/icity_pc/#/index",
      "frameborder": "0",
      "width": "100%",
      "height": "1000"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-zcdx.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jggs"
  }, [_c('div', {
    staticClass: "zcdxTitle"
  }, [_vm._v("兑现事项")]), _vm._v(" "), _c('div', {
    staticClass: "dxsx-item"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "title1"
  }, [_vm._v("广州市促进商务高质量发2023年厂展专项资金居民服务业专专项资金居民服务业专")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("广州市商务局 "), _c('img', {
    attrs: {
      "src": require("../../static/img/details/detail-look.png")
    }
  }), _vm._v("56人看过")])]), _vm._v(" "), _c('div', {
    staticClass: "button-li"
  }, [_c('div', {
    staticClass: "btn1"
  }, [_vm._v("剩2861天")]), _vm._v(" "), _c('div', {
    staticClass: "btn2"
  }, [_vm._v("资金支持")])])]), _vm._v(" "), _c('div', {
    staticClass: "zcdxTitle"
  }, [_vm._v("政策兑换文件")]), _vm._v(" "), _c('ul', {
    staticClass: "list-body"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/policy/#/home"
    }
  }, [_vm._v("2022年度天河区高端专业服务业政策拟支持名单 (第二批)公示")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("2023-02-06")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/policy/#/home"
    }
  }, [_vm._v("2022年度天河区科技创新政策专项(第五批)拟支持名单公示")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("2022-10-18")])]), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/policy/#/home"
    }
  }, [_vm._v("关于2022年天河科技园/天河软件园高质量 发展政策奖励情况审核结果的公示")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("2022-08-29")])]), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/policy/#/home"
    }
  }, [_vm._v("2022年度天河区科技创新政策专项(第一批)拟支持名单公示 ")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("2022-08-29")])]), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://thzwb.thnet.gov.cn/policy/#/home"
    }
  }, [_vm._v("关于2022年天河中央商务区管委会高质量发展政策兑现支持企业名单的公示")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("2022-07-27")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Frequency",
    attrs: {
      "id": "gpsx"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle5.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "freMain"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise2"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon1.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("内资有限责任公司设立登记")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise3"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon1.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("内资有限责任公司变更登记")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise6"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon2.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("企业注册登记档案查询")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon3.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("公共场所卫生许可（新证，含改、扩建)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise13"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon2.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("公众聚集场所投入使用、营业前消防安全检查（告知承诺件）")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc1db18e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SearchDetail.vue
// module id = 1174
// module chunks = 0